import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { fetchSessionDetails } from "../services/paymentService";
import { FaCheckCircle, FaExclamationTriangle } from "react-icons/fa";
import Stepper from "../components/Stepper";

const SuccessPage = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");
  const [sessionDetails, setSessionDetails] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const getSessionDetails = async () => {
      try {
        setLoading(true);
        const data = await fetchSessionDetails(sessionId);
        setSessionDetails(data);
        setError(null);
      } catch (error) {
        console.error(error.message);
        setError("Invalid URL. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    if (sessionId) {
      getSessionDetails();
    } else {
      setError("Invalid URL. Please try again.");
      setLoading(false);
    }
  }, [sessionId]);

  const handleViewReport = () => {
    if (sessionDetails?.metadata?.emissionId) {
      navigate(`/calculator?emissionId=${sessionDetails.metadata.emissionId}`);
    }
  };

  const handleGoToCalculation = () => {
    navigate("/calculator");
  };

  return (
    <div
      className="container mt-5"
      style={{ fontFamily: "Oswald, sans-serif" }}
    >

      <div className="d-flex justify-content-center">
        <Stepper currentStep={4} />
      </div>
      
      {/* Page Heading */}
      <div className="text-center mb-4">
        <h1 style={{ color: "#063970" }}>YPO Carbon Offset Confirmation</h1>
        <p className="text-muted">
          Thank you for contributing to sustainable travel 🌍
        </p>
      </div>

      {/* Stepper: show all steps completed (step 3 successful) */}
      

      {/* Main Card Section */}
      <div className="d-flex justify-content-center">
        {loading ? (
          <div className="text-center">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p>Loading...</p>
          </div>
        ) : error ? (
          <div
            className="card text-center border-danger"
            style={{ maxWidth: "500px", width: "100%" }}
          >
            <div className="card-body">
              <FaExclamationTriangle
                size={40}
                color="#dc3545"
                className="mb-3"
              />
              <h5 className="card-title text-danger">Oops!</h5>
              <p className="card-text">{error}</p>
              <button
                className="btn btn-secondary mt-3"
                onClick={handleGoToCalculation}
              >
                Go to Calculation Page
              </button>
            </div>
          </div>
        ) : (
          <div
            className="card text-center shadow"
            style={{ maxWidth: "500px", width: "100%", borderColor: "#063970" }}
          >
            <div className="card-body">
              <FaCheckCircle size={40} color="#063970" className="mb-3" />
              <h2 className="card-title" style={{ color: "#063970" }}>
                Payment Successful
              </h2>
              <p className="card-text">
                Amount Paid: ${(sessionDetails.amount_total / 100).toFixed(2)}
              </p>
              <p className="card-text">
                Status: {sessionDetails.payment_status}
              </p>
              <button
                className="btn btn-primary mt-3"
                onClick={handleViewReport}
              >
                View Calculation
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SuccessPage;
